var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "container pb-4 pt-0 px-3 px-md-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-lg-4 mt-lg-0 mt-4"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "text-info mb-4"
  }, [_vm._v("By The Numbers")]), _c('div', {
    staticClass: "h5 mb-3 font-weight-normal"
  }, [_c('span', {
    staticClass: "font-weight-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.stateSummary.EntitiesCount))]), _vm._v(" institutions of higher education ")]), _c('div', {
    staticClass: "h5 mb-3 font-weight-normal"
  }, [_c('span', {
    staticClass: "font-weight-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.stateSummary.HistoriesCount))]), _vm._v(" preparation programs ")]), _c('div', {
    staticClass: "h5 font-weight-normal"
  }, [_c('span', {
    staticClass: "font-weight-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.stateSummary.ProgramsCount))]), _vm._v(" endorsement areas ")])])])])]), _c('StateReportHighlights', {
    staticClass: "card mt-4"
  }), _c('ExpandingDataCard', {
    staticClass: "mt-4"
  }), _c('h4', {
    staticClass: "text-secondary mt-5 pb-4"
  }, [_vm._v("Data Snapshots")]), _c('div', {
    staticClass: "card mb-5"
  }, [_vm._m(1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "px-4 py-3 card-body"
  }, [_c('pbi-tile', {
    attrs: {
      "height-ratio": 0.6,
      "page-name": _vm.snapShot1_page,
      "filters": _vm.snapShot1_filters
    }
  }), _c('div', {
    staticClass: "d-flex flex-column flex-md-row mt-md-1",
    attrs: {
      "data-toggle": "buttons",
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn flex-fill flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.Gender ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.Gender;
      }
    }
  }, [_vm._v(" Gender ")]), _c('button', {
    staticClass: "btn my-md-0 my-2 mx-md-1 flex-fill text-nowrap flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.RaceEthnicity ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.RaceEthnicity;
      }
    }
  }, [_vm._v(" Race/Ethnicity ")]), _c('button', {
    staticClass: "btn flex-fill flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.Demographic ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.Demographic;
      }
    }
  }, [_vm._v(" Socio-economic and First Generation ")])])], 1)]), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "divider d-block d-lg-none"
  }), _c('div', {
    staticClass: "card-body pl-lg-0 py-4 py-lg-3"
  }, [_c('h4', {
    staticClass: "mb-4 text-info d-none d-lg-block"
  }, [_vm._v(_vm._s(_vm.cycle.IPPCycleYear) + " Candidate Demographics")]), _c('h5', [_vm._v("What does this mean?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" The demographics of candidates that enter the preparation program by gender, race/ethnicity, socio-economic and first generation subgroups. ")]), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("Why is it included?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("It is important that programs recruit and train a strong, diverse cohort of candidates.")])])])])]), _c('div', {
    staticClass: "card mb-5"
  }, [_vm._m(2), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "px-4 py-3 card-body"
  }, [_c('pbi-tile', {
    attrs: {
      "height-ratio": 0.6,
      "page-name": _vm.snapshotPages.TrendingEnrollment,
      "filters": _vm.snapShot2_filters
    }
  })], 1)]), _vm._m(3)])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('h3', {
    staticClass: "mb-4 text-info"
  }, [_vm._v("About Teaching Preparation in Illinois")]), _c('p', [_vm._v(" Illinois College and University Educator Preparation Programs (EPPs) prepare individuals to serve as teachers in the diverse classrooms of the state's public schools. These state-approved programs are provided at the undergraduate, graduate, and post-baccalaureate levels, and in both traditional and alternative formats to accommodate the wide variety of experiences prospective teachers may have before entering the field. The demand for rigorous preparation programs that produce strong, learner-ready teachers is high due to the number of vacant classrooms in Illinois. ")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent d-lg-none d-block"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Candidate race and ethnicity")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent d-lg-none d-block"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Enrollment/Completers over Time")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "divider d-block d-lg-none"
  }), _c('div', {
    staticClass: "card-body pl-lg-0 py-4 py-lg-3"
  }, [_c('h4', {
    staticClass: "mb-4 text-info d-none d-lg-block"
  }, [_vm._v("Enrollment/Completers over Time")]), _c('h5', [_vm._v("What does this mean?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("The number of individuals that enroll and complete the program in the last five years.")]), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("Why is it included?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" It is important to understand the number of individuals that enroll in a preparation program and the number of individuals that complete a program in a given year. ")])])]);
}];
export { render, staticRenderFns };